module.exports = __webpack_public_path__ + "static/media/4.1d21fb51.jpg";